import { ReactComponent as SuspiciousIcon } from 'img/filetype/flatNew/suspicious.svg';
import React, { memo, ReactElement, useMemo } from 'react';
import { Button } from 'reactApp/ui/Button/Button';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';

import styles from './SuspiciousDialog.css';

interface IProps {
    onSuccess: () => void;
    onClose: () => void;
    filename: string;
}

export const SuspiciousDialog = memo<IProps>(function SuspiciousDialog(props): ReactElement {
    const { onClose, onSuccess, filename } = props;

    const footer = useMemo(
        () => (
            <div>
                <Button theme="vk" fluid onClick={onSuccess}>
                    Скачать
                </Button>
            </div>
        ),
        [onSuccess]
    );

    return (
        <MobileDialog
            id="mobile-suspicious-modal"
            open
            dimmer
            onClose={onClose}
            disableScrolling
            closable
            closeOnDimmerClick
            mod="confirm"
            topmost
            footer={footer}
        >
            <div className={styles.root}>
                <SuspiciousIcon className={styles.icon} />
                <div className={styles.title}>Вы собираетесь скачать файл {filename}</div>
                <div>Файл этого типа может причинить вред вашему устройству. Скачивайте его, только если вы доверяете отправителю.</div>
            </div>
        </MobileDialog>
    );
});
